import { MessagesSection as MessagesSectionBase } from '@/components/messaging/MessagesSection';

export function MessagesSection() {
  return <MessagesSectionBase basePath="/wholesaler/messages" />;
}
